import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { slackPushApi } from '@notifications/slack/api/slack-push.api';
import { SlackPushPayload, SlackPushResponse } from '@notifications/entities/slack-push';

@Injectable()
export class SlackPushService {

  constructor(
    private http: HttpClient) { }

  public sendSlackPushNotification(payload: SlackPushPayload): Observable<SlackPushResponse> {
    return this.http.post<SlackPushResponse>(slackPushApi.slack_push_notification, {
      ...payload, message: JSON.stringify(payload.message)
    });
  }
}
